/* eslint-disable import/no-cycle */
import { log, LOG_LEVELS } from '../../../common/config/app_logger';
import Const from '../const';
import { toCamelCase, withCaptcha } from '../../../common/config/utils';
import { setErrorAction, errorTypes } from '../application/application_action';
import { createPendingWebOrderAPI, editPendingWebOrderAPI, getWebOrderInfoAPI } from '../../utils/api';
import { emailValidated, saveUser } from '../user/user_action';

export const popupThemes = {
  DEFAULT: 'DEFAULT',
  CENTERED: 'CENTERED'
};

export const orderKeys = {
  selectedQuestion: 'selectedQuestion',
  questionInputValue: 'questionInputValue',
  charsCount: 'charsCount',
  selectedAdvisor: 'selectedAdvisor',
  email: 'email',
  nickname: 'nickname',
  gender: 'gender',
  dateOfBirth: 'dateOfBirth',
  screen: 'screen',
  paymentGatewayClient: 'paymentGatewayClient',
  order: 'order',
  reselectAdvisorAction: 'reselectAdvisorAction',
  emailUniqueness: 'emailUniqueness',
  additionalParams: 'additionalParams',
  needRefreshPaymentConfig: 'needRefreshPaymentConfig'
};

const saveToOrderAction = (props) => ({
  type: Const.order.save,
  props
});

const clearOrderAction = (orderKey) => ({
  type: Const.order.clearOrderKey,
  orderKey
});

export const saveToOrder = (props) => (dispatch) => {
  const {
    userId, userMixpanelAliasCreated, nickname, gender, dateOfBirth
  } = props;
  dispatch(saveUser({
    userId, userMixpanelAliasCreated, nickname, gender, dateOfBirth
  }));
  dispatch(saveToOrderAction(props));
};

export const clearOrderKey = (orderKey) => (dispatch) => {
  dispatch(clearOrderAction(orderKey));
};

const initialEmail = (email, emailUniqueness) => (dispatch) => {
  if (emailUniqueness) {
    dispatch(emailValidated(emailUniqueness));
  } else if (email) {
    dispatch(emailValidated(email));
  }
};

const getPendingWebOrderOrEmptyObject = (pendingWebOrder) => pendingWebOrder || {};

const initialOrderHandler = (webOrderInfo) => (dispatch) => {
  const { pendingWebOrder, errors, emailUniqueness } = webOrderInfo;
  const { email, validForSubmission } = getPendingWebOrderOrEmptyObject(pendingWebOrder);
  dispatch(initialEmail(email, emailUniqueness));
  if (!pendingWebOrder) {
    dispatch(saveToOrder({}));
    return;
  }
  if (!validForSubmission) {
    dispatch(saveToOrder({ ...pendingWebOrder, emailUniqueness }));
    dispatch(setErrorAction(toCamelCase(JSON.parse(errors))));
    return;
  }

  log(LOG_LEVELS.INFO, 'Order', 'Initializing order', pendingWebOrder);
  dispatch(saveToOrder(pendingWebOrder));
};

export const initialOrder = () => (dispatch) => {
  getWebOrderInfoAPI().then((webOrderInfo) => {
    dispatch(initialOrderHandler(webOrderInfo));
  }).catch((error) => { dispatch(setErrorAction({ [errorTypes.error]:  error })); });
};

const createPendingWebOrdersPromise = ({ props, dispatch }) => new Promise(
  async (resolve, reject) => {
    withCaptcha('login', (token) => createPendingWebOrderAPI({ ...props, token }).then((res) => {
      const { pendingWebOrder } = res;
      dispatch(saveToOrder(pendingWebOrder));
      resolve(res);
    }).catch((error) => reject(error)));
  }
);

export const createPendingWebOrders = ({ props }) => (dispatch) => (
  createPendingWebOrdersPromise({ props, dispatch })
);

export const editPendingWebOrdersPromise = ({ props, dispatch }) => new Promise(
  async (resolve, reject) => {
    editPendingWebOrderAPI(props).then((res) => {
      const { pendingWebOrder } = res;
      dispatch(saveToOrder(pendingWebOrder));
      resolve(res);
    })
      .catch((error) => reject(error));
  }
);

export const editPendingWebOrders = ({ props }) => (dispatch) => (
  editPendingWebOrdersPromise({ props, dispatch })
);
